/**
 * Constants definition.
 *
 * @type {{BIG_CLIENT: string, RESIDENTIAL: string}}
 */
const CONTRACT_TYPE = {
  BIG_CLIENT: 'BIG_CLIENT',
  RESIDENTIAL: 'RESIDENTIAL',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const CONTRACT_TYPE_ENUM = Object.keys(CONTRACT_TYPE);

const BIG_CLIENT = CONTRACT_TYPE_ENUM[0];
const RESIDENTIAL = CONTRACT_TYPE_ENUM[1];

export {
  CONTRACT_TYPE,
  BIG_CLIENT,
  RESIDENTIAL,
  CONTRACT_TYPE_ENUM,
};
